import { render, staticRenderFns } from "./PlayerBanLog.vue?vue&type=template&id=7a00ed6d&scoped=true&"
import script from "./PlayerBanLog.vue?vue&type=script&lang=js&"
export * from "./PlayerBanLog.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBanLog.vue?vue&type=style&index=0&id=7a00ed6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a00ed6d",
  null
  
)

export default component.exports